import { CLUB_REQUIRED, EMAIL_INVALID, EMAIL_REQUIRED, LOCATION_REQUIRED } from '@/constants/MessageConstants'
import * as Yup from 'yup'

const EditClubValidationSchema = Yup.object().shape({
  clubName: Yup.string().required(CLUB_REQUIRED),
  email: Yup.string().email(EMAIL_INVALID).required(EMAIL_REQUIRED),
  address: Yup.object()
    .shape({
      description: Yup.string().required(LOCATION_REQUIRED),
      placeId: Yup.string().notRequired(),
    })
    .required(),
})

export default EditClubValidationSchema
